const LoginOverlay = () => {
  return (
    <svg
      width='100%'
      height='100%'
      viewBox='0 0 720 960'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g opacity='0.4'>
        <mask
          id='mask0_3144_46565'
          style={{ maskType: 'alpha' }}
          maskUnits='userSpaceOnUse'
          x='-120'
          y='0'
          width='960'
          height='960'
        >
          <rect
            width='960'
            height='960'
            transform='matrix(-1 0 0 1 840 0)'
            fill='url(#paint0_radial_3144_46565)'
          />
        </mask>
        <g mask='url(#mask0_3144_46565)'>
          <g clipPath='url(#clip0_3144_46565)'>
            <mask id='path-3-inside-1_3144_46565' fill='white'>
              <path d='M744 0H648V96H744V0Z' />
            </mask>
            <path
              d='M648 96V97H647V96H648ZM648 0H649V96H648H647V0H648ZM648 96V95H744V96V97H648V96Z'
              fill='white'
              mask='url(#path-3-inside-1_3144_46565)'
            />
            <mask id='path-5-inside-2_3144_46565' fill='white'>
              <path d='M648 0H552V96H648V0Z' />
            </mask>
            <path
              d='M552 96V97H551V96H552ZM552 0H553V96H552H551V0H552ZM552 96V95H648V96V97H552V96Z'
              fill='white'
              mask='url(#path-5-inside-2_3144_46565)'
            />
            <mask id='path-7-inside-3_3144_46565' fill='white'>
              <path d='M552 0H456V96H552V0Z' />
            </mask>
            <path
              d='M456 96V97H455V96H456ZM456 0H457V96H456H455V0H456ZM456 96V95H552V96V97H456V96Z'
              fill='white'
              mask='url(#path-7-inside-3_3144_46565)'
            />
            <mask id='path-9-inside-4_3144_46565' fill='white'>
              <path d='M456 0H360V96H456V0Z' />
            </mask>
            <path
              d='M360 96V97H359V96H360ZM360 0H361V96H360H359V0H360ZM360 96V95H456V96V97H360V96Z'
              fill='white'
              mask='url(#path-9-inside-4_3144_46565)'
            />
            <mask id='path-11-inside-5_3144_46565' fill='white'>
              <path d='M360 0H264V96H360V0Z' />
            </mask>
            <path
              d='M264 96V97H263V96H264ZM264 0H265V96H264H263V0H264ZM264 96V95H360V96V97H264V96Z'
              fill='white'
              mask='url(#path-11-inside-5_3144_46565)'
            />
            <mask id='path-13-inside-6_3144_46565' fill='white'>
              <path d='M264 0H168V96H264V0Z' />
            </mask>
            <path
              d='M168 96V97H167V96H168ZM168 0H169V96H168H167V0H168ZM168 96V95H264V96V97H168V96Z'
              fill='white'
              mask='url(#path-13-inside-6_3144_46565)'
            />
            <mask id='path-15-inside-7_3144_46565' fill='white'>
              <path d='M168 0H72V96H168V0Z' />
            </mask>
            <path
              d='M72 96V97H71V96H72ZM72 0H73V96H72H71V0H72ZM72 96V95H168V96V97H72V96Z'
              fill='white'
              mask='url(#path-15-inside-7_3144_46565)'
            />
            <mask id='path-17-inside-8_3144_46565' fill='white'>
              <path d='M72 0H-24V96H72V0Z' />
            </mask>
            <path
              d='M-24 96V97H-25V96H-24ZM-24 0H-23V96H-24H-25V0H-24ZM-24 96V95H72V96V97H-24V96Z'
              fill='white'
              mask='url(#path-17-inside-8_3144_46565)'
            />
            <mask id='path-19-inside-9_3144_46565' fill='white'>
              <path d='M744 96H648V192H744V96Z' />
            </mask>
            <path
              d='M648 192V193H647V192H648ZM648 96H649V192H648H647V96H648ZM648 192V191H744V192V193H648V192Z'
              fill='white'
              mask='url(#path-19-inside-9_3144_46565)'
            />
            <mask id='path-21-inside-10_3144_46565' fill='white'>
              <path d='M648 96H552V192H648V96Z' />
            </mask>
            <path d='M648 96H552V192H648V96Z' fill='white' />
            <path
              d='M552 192V193H551V192H552ZM552 96H553V192H552H551V96H552ZM552 192V191H648V192V193H552V192Z'
              fill='white'
              mask='url(#path-21-inside-10_3144_46565)'
            />
            <mask id='path-23-inside-11_3144_46565' fill='white'>
              <path d='M552 96H456V192H552V96Z' />
            </mask>
            <path
              d='M456 192V193H455V192H456ZM456 96H457V192H456H455V96H456ZM456 192V191H552V192V193H456V192Z'
              fill='white'
              mask='url(#path-23-inside-11_3144_46565)'
            />
            <mask id='path-25-inside-12_3144_46565' fill='white'>
              <path d='M456 96H360V192H456V96Z' />
            </mask>
            <path
              d='M360 192V193H359V192H360ZM360 96H361V192H360H359V96H360ZM360 192V191H456V192V193H360V192Z'
              fill='white'
              mask='url(#path-25-inside-12_3144_46565)'
            />
            <mask id='path-27-inside-13_3144_46565' fill='white'>
              <path d='M360 96H264V192H360V96Z' />
            </mask>
            <path
              d='M264 192V193H263V192H264ZM264 96H265V192H264H263V96H264ZM264 192V191H360V192V193H264V192Z'
              fill='white'
              mask='url(#path-27-inside-13_3144_46565)'
            />
            <mask id='path-29-inside-14_3144_46565' fill='white'>
              <path d='M264 96H168V192H264V96Z' />
            </mask>
            <path
              d='M168 192V193H167V192H168ZM168 96H169V192H168H167V96H168ZM168 192V191H264V192V193H168V192Z'
              fill='white'
              mask='url(#path-29-inside-14_3144_46565)'
            />
            <mask id='path-31-inside-15_3144_46565' fill='white'>
              <path d='M168 96H72V192H168V96Z' />
            </mask>
            <path
              d='M72 192V193H71V192H72ZM72 96H73V192H72H71V96H72ZM72 192V191H168V192V193H72V192Z'
              fill='white'
              mask='url(#path-31-inside-15_3144_46565)'
            />
            <mask id='path-33-inside-16_3144_46565' fill='white'>
              <path d='M72 96H-24V192H72V96Z' />
            </mask>
            <path d='M72 96H-24V192H72V96Z' fill='white' />
            <path
              d='M-24 192V193H-25V192H-24ZM-24 96H-23V192H-24H-25V96H-24ZM-24 192V191H72V192V193H-24V192Z'
              fill='white'
              mask='url(#path-33-inside-16_3144_46565)'
            />
            <mask id='path-35-inside-17_3144_46565' fill='white'>
              <path d='M744 192H648V288H744V192Z' />
            </mask>
            <path
              d='M648 288V289H647V288H648ZM648 192H649V288H648H647V192H648ZM648 288V287H744V288V289H648V288Z'
              fill='white'
              mask='url(#path-35-inside-17_3144_46565)'
            />
            <mask id='path-37-inside-18_3144_46565' fill='white'>
              <path d='M648 192H552V288H648V192Z' />
            </mask>
            <path
              d='M552 288V289H551V288H552ZM552 192H553V288H552H551V192H552ZM552 288V287H648V288V289H552V288Z'
              fill='white'
              mask='url(#path-37-inside-18_3144_46565)'
            />
            <mask id='path-39-inside-19_3144_46565' fill='white'>
              <path d='M552 192H456V288H552V192Z' />
            </mask>
            <path
              d='M456 288V289H455V288H456ZM456 192H457V288H456H455V192H456ZM456 288V287H552V288V289H456V288Z'
              fill='white'
              mask='url(#path-39-inside-19_3144_46565)'
            />
            <mask id='path-41-inside-20_3144_46565' fill='white'>
              <path d='M456 192H360V288H456V192Z' />
            </mask>
            <path
              d='M360 288V289H359V288H360ZM360 192H361V288H360H359V192H360ZM360 288V287H456V288V289H360V288Z'
              fill='white'
              mask='url(#path-41-inside-20_3144_46565)'
            />
            <mask id='path-43-inside-21_3144_46565' fill='white'>
              <path d='M360 192H264V288H360V192Z' />
            </mask>
            <path
              d='M264 288V289H263V288H264ZM264 192H265V288H264H263V192H264ZM264 288V287H360V288V289H264V288Z'
              fill='white'
              mask='url(#path-43-inside-21_3144_46565)'
            />
            <mask id='path-45-inside-22_3144_46565' fill='white'>
              <path d='M264 192H168V288H264V192Z' />
            </mask>
            <path d='M264 192H168V288H264V192Z' fill='white' />
            <path
              d='M168 288V289H167V288H168ZM168 192H169V288H168H167V192H168ZM168 288V287H264V288V289H168V288Z'
              fill='white'
              mask='url(#path-45-inside-22_3144_46565)'
            />
            <mask id='path-47-inside-23_3144_46565' fill='white'>
              <path d='M168 192H72V288H168V192Z' />
            </mask>
            <path
              d='M72 288V289H71V288H72ZM72 192H73V288H72H71V192H72ZM72 288V287H168V288V289H72V288Z'
              fill='white'
              mask='url(#path-47-inside-23_3144_46565)'
            />
            <mask id='path-49-inside-24_3144_46565' fill='white'>
              <path d='M72 192H-24V288H72V192Z' />
            </mask>
            <path
              d='M-24 288V289H-25V288H-24ZM-24 192H-23V288H-24H-25V192H-24ZM-24 288V287H72V288V289H-24V288Z'
              fill='white'
              mask='url(#path-49-inside-24_3144_46565)'
            />
            <mask id='path-51-inside-25_3144_46565' fill='white'>
              <path d='M744 288H648V384H744V288Z' />
            </mask>
            <path
              d='M648 384V385H647V384H648ZM648 288H649V384H648H647V288H648ZM648 384V383H744V384V385H648V384Z'
              fill='white'
              mask='url(#path-51-inside-25_3144_46565)'
            />
            <mask id='path-53-inside-26_3144_46565' fill='white'>
              <path d='M648 288H552V384H648V288Z' />
            </mask>
            <path
              d='M552 384V385H551V384H552ZM552 288H553V384H552H551V288H552ZM552 384V383H648V384V385H552V384Z'
              fill='white'
              mask='url(#path-53-inside-26_3144_46565)'
            />
            <mask id='path-55-inside-27_3144_46565' fill='white'>
              <path d='M552 288H456V384H552V288Z' />
            </mask>
            <path
              d='M456 384V385H455V384H456ZM456 288H457V384H456H455V288H456ZM456 384V383H552V384V385H456V384Z'
              fill='white'
              mask='url(#path-55-inside-27_3144_46565)'
            />
            <mask id='path-57-inside-28_3144_46565' fill='white'>
              <path d='M456 288H360V384H456V288Z' />
            </mask>
            <path
              d='M360 384V385H359V384H360ZM360 288H361V384H360H359V288H360ZM360 384V383H456V384V385H360V384Z'
              fill='white'
              mask='url(#path-57-inside-28_3144_46565)'
            />
            <mask id='path-59-inside-29_3144_46565' fill='white'>
              <path d='M360 288H264V384H360V288Z' />
            </mask>
            <path
              d='M264 384V385H263V384H264ZM264 288H265V384H264H263V288H264ZM264 384V383H360V384V385H264V384Z'
              fill='white'
              mask='url(#path-59-inside-29_3144_46565)'
            />
            <mask id='path-61-inside-30_3144_46565' fill='white'>
              <path d='M264 288H168V384H264V288Z' />
            </mask>
            <path
              d='M168 384V385H167V384H168ZM168 288H169V384H168H167V288H168ZM168 384V383H264V384V385H168V384Z'
              fill='white'
              mask='url(#path-61-inside-30_3144_46565)'
            />
            <mask id='path-63-inside-31_3144_46565' fill='white'>
              <path d='M168 288H72V384H168V288Z' />
            </mask>
            <path
              d='M72 384V385H71V384H72ZM72 288H73V384H72H71V288H72ZM72 384V383H168V384V385H72V384Z'
              fill='white'
              mask='url(#path-63-inside-31_3144_46565)'
            />
            <mask id='path-65-inside-32_3144_46565' fill='white'>
              <path d='M72 288H-24V384H72V288Z' />
            </mask>
            <path
              d='M-24 384V385H-25V384H-24ZM-24 288H-23V384H-24H-25V288H-24ZM-24 384V383H72V384V385H-24V384Z'
              fill='white'
              mask='url(#path-65-inside-32_3144_46565)'
            />
            <mask id='path-67-inside-33_3144_46565' fill='white'>
              <path d='M744 384H648V480H744V384Z' />
            </mask>
            <path
              d='M648 480V481H647V480H648ZM648 384H649V480H648H647V384H648ZM648 480V479H744V480V481H648V480Z'
              fill='white'
              mask='url(#path-67-inside-33_3144_46565)'
            />
            <mask id='path-69-inside-34_3144_46565' fill='white'>
              <path d='M648 384H552V480H648V384Z' />
            </mask>
            <path
              d='M552 480V481H551V480H552ZM552 384H553V480H552H551V384H552ZM552 480V479H648V480V481H552V480Z'
              fill='white'
              mask='url(#path-69-inside-34_3144_46565)'
            />
            <mask id='path-71-inside-35_3144_46565' fill='white'>
              <path d='M552 384H456V480H552V384Z' />
            </mask>
            <path d='M552 384H456V480H552V384Z' fill='white' />
            <path
              d='M456 480V481H455V480H456ZM456 384H457V480H456H455V384H456ZM456 480V479H552V480V481H456V480Z'
              fill='white'
              mask='url(#path-71-inside-35_3144_46565)'
            />
            <mask id='path-73-inside-36_3144_46565' fill='white'>
              <path d='M456 384H360V480H456V384Z' />
            </mask>
            <path
              d='M360 480V481H359V480H360ZM360 384H361V480H360H359V384H360ZM360 480V479H456V480V481H360V480Z'
              fill='white'
              mask='url(#path-73-inside-36_3144_46565)'
            />
            <mask id='path-75-inside-37_3144_46565' fill='white'>
              <path d='M360 384H264V480H360V384Z' />
            </mask>
            <path
              d='M264 480V481H263V480H264ZM264 384H265V480H264H263V384H264ZM264 480V479H360V480V481H264V480Z'
              fill='white'
              mask='url(#path-75-inside-37_3144_46565)'
            />
            <mask id='path-77-inside-38_3144_46565' fill='white'>
              <path d='M264 384H168V480H264V384Z' />
            </mask>
            <path
              d='M168 480V481H167V480H168ZM168 384H169V480H168H167V384H168ZM168 480V479H264V480V481H168V480Z'
              fill='white'
              mask='url(#path-77-inside-38_3144_46565)'
            />
            <mask id='path-79-inside-39_3144_46565' fill='white'>
              <path d='M168 384H72V480H168V384Z' />
            </mask>
            <path
              d='M72 480V481H71V480H72ZM72 384H73V480H72H71V384H72ZM72 480V479H168V480V481H72V480Z'
              fill='white'
              mask='url(#path-79-inside-39_3144_46565)'
            />
            <mask id='path-81-inside-40_3144_46565' fill='white'>
              <path d='M72 384H-24V480H72V384Z' />
            </mask>
            <path
              d='M-24 480V481H-25V480H-24ZM-24 384H-23V480H-24H-25V384H-24ZM-24 480V479H72V480V481H-24V480Z'
              fill='white'
              mask='url(#path-81-inside-40_3144_46565)'
            />
            <mask id='path-83-inside-41_3144_46565' fill='white'>
              <path d='M744 480H648V576H744V480Z' />
            </mask>
            <path
              d='M648 576V577H647V576H648ZM648 480H649V576H648H647V480H648ZM648 576V575H744V576V577H648V576Z'
              fill='white'
              mask='url(#path-83-inside-41_3144_46565)'
            />
            <mask id='path-85-inside-42_3144_46565' fill='white'>
              <path d='M648 480H552V576H648V480Z' />
            </mask>
            <path
              d='M552 576V577H551V576H552ZM552 480H553V576H552H551V480H552ZM552 576V575H648V576V577H552V576Z'
              fill='white'
              mask='url(#path-85-inside-42_3144_46565)'
            />
            <mask id='path-87-inside-43_3144_46565' fill='white'>
              <path d='M552 480H456V576H552V480Z' />
            </mask>
            <path
              d='M456 576V577H455V576H456ZM456 480H457V576H456H455V480H456ZM456 576V575H552V576V577H456V576Z'
              fill='white'
              mask='url(#path-87-inside-43_3144_46565)'
            />
            <mask id='path-89-inside-44_3144_46565' fill='white'>
              <path d='M456 480H360V576H456V480Z' />
            </mask>
            <path
              d='M360 576V577H359V576H360ZM360 480H361V576H360H359V480H360ZM360 576V575H456V576V577H360V576Z'
              fill='white'
              mask='url(#path-89-inside-44_3144_46565)'
            />
            <mask id='path-91-inside-45_3144_46565' fill='white'>
              <path d='M360 480H264V576H360V480Z' />
            </mask>
            <path
              d='M264 576V577H263V576H264ZM264 480H265V576H264H263V480H264ZM264 576V575H360V576V577H264V576Z'
              fill='white'
              mask='url(#path-91-inside-45_3144_46565)'
            />
            <mask id='path-93-inside-46_3144_46565' fill='white'>
              <path d='M264 480H168V576H264V480Z' />
            </mask>
            <path d='M264 480H168V576H264V480Z' fill='white' />
            <path
              d='M168 576V577H167V576H168ZM168 480H169V576H168H167V480H168ZM168 576V575H264V576V577H168V576Z'
              fill='white'
              mask='url(#path-93-inside-46_3144_46565)'
            />
            <mask id='path-95-inside-47_3144_46565' fill='white'>
              <path d='M168 480H72V576H168V480Z' />
            </mask>
            <path
              d='M72 576V577H71V576H72ZM72 480H73V576H72H71V480H72ZM72 576V575H168V576V577H72V576Z'
              fill='white'
              mask='url(#path-95-inside-47_3144_46565)'
            />
            <mask id='path-97-inside-48_3144_46565' fill='white'>
              <path d='M72 480H-24V576H72V480Z' />
            </mask>
            <path
              d='M-24 576V577H-25V576H-24ZM-24 480H-23V576H-24H-25V480H-24ZM-24 576V575H72V576V577H-24V576Z'
              fill='white'
              mask='url(#path-97-inside-48_3144_46565)'
            />
            <mask id='path-99-inside-49_3144_46565' fill='white'>
              <path d='M744 576H648V672H744V576Z' />
            </mask>
            <path
              d='M648 672V673H647V672H648ZM648 576H649V672H648H647V576H648ZM648 672V671H744V672V673H648V672Z'
              fill='white'
              mask='url(#path-99-inside-49_3144_46565)'
            />
            <mask id='path-101-inside-50_3144_46565' fill='white'>
              <path d='M648 576H552V672H648V576Z' />
            </mask>
            <path
              d='M552 672V673H551V672H552ZM552 576H553V672H552H551V576H552ZM552 672V671H648V672V673H552V672Z'
              fill='white'
              mask='url(#path-101-inside-50_3144_46565)'
            />
            <mask id='path-103-inside-51_3144_46565' fill='white'>
              <path d='M552 576H456V672H552V576Z' />
            </mask>
            <path
              d='M456 672V673H455V672H456ZM456 576H457V672H456H455V576H456ZM456 672V671H552V672V673H456V672Z'
              fill='white'
              mask='url(#path-103-inside-51_3144_46565)'
            />
            <mask id='path-105-inside-52_3144_46565' fill='white'>
              <path d='M456 576H360V672H456V576Z' />
            </mask>
            <path
              d='M360 672V673H359V672H360ZM360 576H361V672H360H359V576H360ZM360 672V671H456V672V673H360V672Z'
              fill='white'
              mask='url(#path-105-inside-52_3144_46565)'
            />
            <mask id='path-107-inside-53_3144_46565' fill='white'>
              <path d='M360 576H264V672H360V576Z' />
            </mask>
            <path
              d='M264 672V673H263V672H264ZM264 576H265V672H264H263V576H264ZM264 672V671H360V672V673H264V672Z'
              fill='white'
              mask='url(#path-107-inside-53_3144_46565)'
            />
            <mask id='path-109-inside-54_3144_46565' fill='white'>
              <path d='M264 576H168V672H264V576Z' />
            </mask>
            <path
              d='M168 672V673H167V672H168ZM168 576H169V672H168H167V576H168ZM168 672V671H264V672V673H168V672Z'
              fill='white'
              mask='url(#path-109-inside-54_3144_46565)'
            />
            <mask id='path-111-inside-55_3144_46565' fill='white'>
              <path d='M168 576H72V672H168V576Z' />
            </mask>
            <path
              d='M72 672V673H71V672H72ZM72 576H73V672H72H71V576H72ZM72 672V671H168V672V673H72V672Z'
              fill='white'
              mask='url(#path-111-inside-55_3144_46565)'
            />
            <mask id='path-113-inside-56_3144_46565' fill='white'>
              <path d='M72 576H-24V672H72V576Z' />
            </mask>
            <path
              d='M-24 672V673H-25V672H-24ZM-24 576H-23V672H-24H-25V576H-24ZM-24 672V671H72V672V673H-24V672Z'
              fill='white'
              mask='url(#path-113-inside-56_3144_46565)'
            />
            <mask id='path-115-inside-57_3144_46565' fill='white'>
              <path d='M744 672H648V768H744V672Z' />
            </mask>
            <path
              d='M648 768V769H647V768H648ZM648 672H649V768H648H647V672H648ZM648 768V767H744V768V769H648V768Z'
              fill='white'
              mask='url(#path-115-inside-57_3144_46565)'
            />
            <mask id='path-117-inside-58_3144_46565' fill='white'>
              <path d='M648 672H552V768H648V672Z' />
            </mask>
            <path
              d='M552 768V769H551V768H552ZM552 672H553V768H552H551V672H552ZM552 768V767H648V768V769H552V768Z'
              fill='white'
              mask='url(#path-117-inside-58_3144_46565)'
            />
            <mask id='path-119-inside-59_3144_46565' fill='white'>
              <path d='M552 672H456V768H552V672Z' />
            </mask>
            <path d='M552 672H456V768H552V672Z' fill='white' />
            <path
              d='M456 768V769H455V768H456ZM456 672H457V768H456H455V672H456ZM456 768V767H552V768V769H456V768Z'
              fill='white'
              mask='url(#path-119-inside-59_3144_46565)'
            />
            <mask id='path-121-inside-60_3144_46565' fill='white'>
              <path d='M456 672H360V768H456V672Z' />
            </mask>
            <path
              d='M360 768V769H359V768H360ZM360 672H361V768H360H359V672H360ZM360 768V767H456V768V769H360V768Z'
              fill='white'
              mask='url(#path-121-inside-60_3144_46565)'
            />
            <mask id='path-123-inside-61_3144_46565' fill='white'>
              <path d='M360 672H264V768H360V672Z' />
            </mask>
            <path
              d='M264 768V769H263V768H264ZM264 672H265V768H264H263V672H264ZM264 768V767H360V768V769H264V768Z'
              fill='white'
              mask='url(#path-123-inside-61_3144_46565)'
            />
            <mask id='path-125-inside-62_3144_46565' fill='white'>
              <path d='M264 672H168V768H264V672Z' />
            </mask>
            <path
              d='M168 768V769H167V768H168ZM168 672H169V768H168H167V672H168ZM168 768V767H264V768V769H168V768Z'
              fill='white'
              mask='url(#path-125-inside-62_3144_46565)'
            />
            <mask id='path-127-inside-63_3144_46565' fill='white'>
              <path d='M168 672H72V768H168V672Z' />
            </mask>
            <path
              d='M72 768V769H71V768H72ZM72 672H73V768H72H71V672H72ZM72 768V767H168V768V769H72V768Z'
              fill='white'
              mask='url(#path-127-inside-63_3144_46565)'
            />
            <mask id='path-129-inside-64_3144_46565' fill='white'>
              <path d='M72 672H-24V768H72V672Z' />
            </mask>
            <path
              d='M-24 768V769H-25V768H-24ZM-24 672H-23V768H-24H-25V672H-24ZM-24 768V767H72V768V769H-24V768Z'
              fill='white'
              mask='url(#path-129-inside-64_3144_46565)'
            />
            <mask id='path-131-inside-65_3144_46565' fill='white'>
              <path d='M744 768H648V864H744V768Z' />
            </mask>
            <path
              d='M648 864V865H647V864H648ZM648 768H649V864H648H647V768H648ZM648 864V863H744V864V865H648V864Z'
              fill='white'
              mask='url(#path-131-inside-65_3144_46565)'
            />
            <mask id='path-133-inside-66_3144_46565' fill='white'>
              <path d='M648 768H552V864H648V768Z' />
            </mask>
            <path
              d='M552 864V865H551V864H552ZM552 768H553V864H552H551V768H552ZM552 864V863H648V864V865H552V864Z'
              fill='white'
              mask='url(#path-133-inside-66_3144_46565)'
            />
            <mask id='path-135-inside-67_3144_46565' fill='white'>
              <path d='M552 768H456V864H552V768Z' />
            </mask>
            <path
              d='M456 864V865H455V864H456ZM456 768H457V864H456H455V768H456ZM456 864V863H552V864V865H456V864Z'
              fill='white'
              mask='url(#path-135-inside-67_3144_46565)'
            />
            <mask id='path-137-inside-68_3144_46565' fill='white'>
              <path d='M456 768H360V864H456V768Z' />
            </mask>
            <path
              d='M360 864V865H359V864H360ZM360 768H361V864H360H359V768H360ZM360 864V863H456V864V865H360V864Z'
              fill='white'
              mask='url(#path-137-inside-68_3144_46565)'
            />
            <mask id='path-139-inside-69_3144_46565' fill='white'>
              <path d='M360 768H264V864H360V768Z' />
            </mask>
            <path
              d='M264 864V865H263V864H264ZM264 768H265V864H264H263V768H264ZM264 864V863H360V864V865H264V864Z'
              fill='white'
              mask='url(#path-139-inside-69_3144_46565)'
            />
            <mask id='path-141-inside-70_3144_46565' fill='white'>
              <path d='M264 768H168V864H264V768Z' />
            </mask>
            <path d='M264 768H168V864H264V768Z' fill='white' />
            <path
              d='M168 864V865H167V864H168ZM168 768H169V864H168H167V768H168ZM168 864V863H264V864V865H168V864Z'
              fill='white'
              mask='url(#path-141-inside-70_3144_46565)'
            />
            <mask id='path-143-inside-71_3144_46565' fill='white'>
              <path d='M168 768H72V864H168V768Z' />
            </mask>
            <path
              d='M72 864V865H71V864H72ZM72 768H73V864H72H71V768H72ZM72 864V863H168V864V865H72V864Z'
              fill='white'
              mask='url(#path-143-inside-71_3144_46565)'
            />
            <mask id='path-145-inside-72_3144_46565' fill='white'>
              <path d='M72 768H-24V864H72V768Z' />
            </mask>
            <path
              d='M-24 864V865H-25V864H-24ZM-24 768H-23V864H-24H-25V768H-24ZM-24 864V863H72V864V865H-24V864Z'
              fill='white'
              mask='url(#path-145-inside-72_3144_46565)'
            />
            <mask id='path-147-inside-73_3144_46565' fill='white'>
              <path d='M744 864H648V960H744V864Z' />
            </mask>
            <path
              d='M648 960V961H647V960H648ZM648 864H649V960H648H647V864H648ZM648 960V959H744V960V961H648V960Z'
              fill='white'
              mask='url(#path-147-inside-73_3144_46565)'
            />
            <mask id='path-149-inside-74_3144_46565' fill='white'>
              <path d='M648 864H552V960H648V864Z' />
            </mask>
            <path
              d='M552 960V961H551V960H552ZM552 864H553V960H552H551V864H552ZM552 960V959H648V960V961H552V960Z'
              fill='white'
              mask='url(#path-149-inside-74_3144_46565)'
            />
            <mask id='path-151-inside-75_3144_46565' fill='white'>
              <path d='M552 864H456V960H552V864Z' />
            </mask>
            <path
              d='M456 960V961H455V960H456ZM456 864H457V960H456H455V864H456ZM456 960V959H552V960V961H456V960Z'
              fill='white'
              mask='url(#path-151-inside-75_3144_46565)'
            />
            <mask id='path-153-inside-76_3144_46565' fill='white'>
              <path d='M456 864H360V960H456V864Z' />
            </mask>
            <path
              d='M360 960V961H359V960H360ZM360 864H361V960H360H359V864H360ZM360 960V959H456V960V961H360V960Z'
              fill='white'
              mask='url(#path-153-inside-76_3144_46565)'
            />
            <mask id='path-155-inside-77_3144_46565' fill='white'>
              <path d='M360 864H264V960H360V864Z' />
            </mask>
            <path
              d='M264 960V961H263V960H264ZM264 864H265V960H264H263V864H264ZM264 960V959H360V960V961H264V960Z'
              fill='white'
              mask='url(#path-155-inside-77_3144_46565)'
            />
            <mask id='path-157-inside-78_3144_46565' fill='white'>
              <path d='M264 864H168V960H264V864Z' />
            </mask>
            <path
              d='M168 960V961H167V960H168ZM168 864H169V960H168H167V864H168ZM168 960V959H264V960V961H168V960Z'
              fill='white'
              mask='url(#path-157-inside-78_3144_46565)'
            />
            <mask id='path-159-inside-79_3144_46565' fill='white'>
              <path d='M168 864H72V960H168V864Z' />
            </mask>
            <path
              d='M72 960V961H71V960H72ZM72 864H73V960H72H71V864H72ZM72 960V959H168V960V961H72V960Z'
              fill='white'
              mask='url(#path-159-inside-79_3144_46565)'
            />
            <mask id='path-161-inside-80_3144_46565' fill='white'>
              <path d='M72 864H-24V960H72V864Z' />
            </mask>
            <path
              d='M-24 960V961H-25V960H-24ZM-24 864H-23V960H-24H-25V864H-24ZM-24 960V959H72V960V961H-24V960Z'
              fill='white'
              mask='url(#path-161-inside-80_3144_46565)'
            />
          </g>
          <rect
            x='-0.5'
            y='0.5'
            width='959'
            height='959'
            transform='matrix(-1 0 0 1 839 0)'
            stroke='white'
          />
        </g>
      </g>
      <defs>
        <radialGradient
          id='paint0_radial_3144_46565'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(480 -0.000114441) rotate(90) scale(960 501.059)'
        >
          <stop />
          <stop offset='0.953125' stopOpacity='0' />
        </radialGradient>
        <clipPath id='clip0_3144_46565'>
          <rect
            width='960'
            height='960'
            transform='matrix(-1 0 0 1 840 0)'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default LoginOverlay
